////// Lib. //////
//////////////////

import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
gsap.registerPlugin(Draggable);

///// Util. //////
//////////////////

// ...

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. items"],
  end: ["init. items", "init. success"],
};

/// Init. def. ///
//////////////////

export default function init_items() {
  ///// Setup //////
  //////////////////

  // const el_comp = this.element;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  ///// Action /////
  //////////////////

  const { items } = this.ref;
  items.forEach((it) => {
    gsap.set(it, { cursor: "grab" });

    // Slight scale-up on hover //
    it.addEventListener("mouseenter", () => {
      gsap.to(it, { scale: 1.05, duration: 0.3, ease: "power2.out" });
    });
    it.addEventListener("mouseleave", () => {
      gsap.to(it, { scale: 1, duration: 0.3, ease: "power2.out" });
    });

    // Draggable init. //
    Draggable.create(it, {
      type: "x,y",

      edgeResistance: 0.65,
      // bounds: "body",
      bounds: this.element,
      onPress: function () {
        gsap.to(this.target, { cursor: "grabbing", scale: 1.1, duration: 0.2 });
      },
      onRelease: function () {
        gsap.to(this.target, { cursor: "grab", scale: 1, duration: 0.2 });
      },
    });
  });

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
